import { createSelector } from "reselect";

const selectSummary = state => state.summary;

export const selectIsModalVisible = createSelector(
  [selectSummary],
  summary => summary.isModalVisible
);
